import React from "react"
import { Box, Paper } from "@mui/material"

import { makeStyles } from "makeStyles"

import Link from "components/i18n/Link"
import Price from "components/Price"
import LazyLoadedImage from "components/LazyLoadedImage"

import { AlgoliaLockingSystemHit } from "@secureo/common/typings/Algolia"

const useStyles = makeStyles()({
	title: {
		color: "black",
		cursor: "pointer",
		height: 40,
		width: "100%",
	},
	product: {
		boxShadow: "none",
		borderRadius: 10,
		transition: "0.3s",
		border: "1px solid #E3E5E6",
		"&:hover": {
			border: "1px solid #4691CE",
			boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			"& $button": {
				background: "#4691CE",
				color: "white",
				boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			},
			"& $title": {
				color: "#4691CE",
			},
		},
		"@media only screen and (max-width: 600px)": {
			borderRadius: 0,
			height: "100%",
		},
	},
})

const LockingSystemMobileViewItem = ({ hit }: Props) => {
	const { classes } = useStyles()

	const { name, image, slug, securityScore = null, grossPriceCents } = hit

	return (
		<Link href={`/locking-system/${slug}`}>
			<div style={{ position: "relative" }}>
				<Paper className={classes.product}>
					<Box p={2} style={{ display: "flex", flexDirection: "column" }}>
						{/* Product Image */}
						<div>
							<Box style={{ textAlign: "center" }}>
								<LazyLoadedImage
									alt={name}
									title={name}
									src={image}
									style={{
										height: 82,
										maxWidth: "100%",
										objectFit: "contain",
										width: "100%",
										margin: "auto",
									}}
								/>
							</Box>
						</div>
						<div>
							<Box className={classes.title} style={{ fontSize: 12 }}>
								<strong>{name}</strong>
								{securityScore !== null && (
									<span>
										<br />
										Sicherheitsstufe: {securityScore} / 10
									</span>
								)}
							</Box>
						</div>
					</Box>
					<Box p={2} style={{ flex: "1 0 auto" }}>
						{/* Price */}
						<strong style={{ fontSize: 14, marginRight: 5 }}>
							<Price priceInEuroCents={grossPriceCents} />
						</strong>
						<span style={{ color: "grey", fontSize: 10 }}>inkl. MwSt.</span>
					</Box>
				</Paper>
			</div>
		</Link>
	)
}

interface Props {
	hit: AlgoliaLockingSystemHit
	locale: string
	position: number
	categoryName: string
	listName?: string
}

export default LockingSystemMobileViewItem
